import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

// Representantes e vendedores (comercial) do cliente — mesma base de Customer
// usada por client.service.js. Comercial é sub-recurso do Representante
// selecionado: GET /representatives/{id}/sales (issue #490).
const basePath = `${API_URLS.CUSTOMERS}/representatives`;

async function fetchRepresentatives() {
  try {
    let response = await api.get(basePath);
    let treated = errorHandling.handleResponse(
      response,
      "representativesService.fetchRepresentatives"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "representativesService.fetchRepresentatives");
    return null;
  }
}

async function fetchSalespeople(representativeId) {
  try {
    let response = await api.get(`${basePath}/${representativeId}/sales`);
    let treated = errorHandling.handleResponse(
      response,
      "representativesService.fetchSalespeople"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "representativesService.fetchSalespeople");
    return null;
  }
}

export const representativesService = {
  fetchRepresentatives,
  fetchSalespeople,
};
